import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export default class Tibbit26StartNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Tibbit 26 Start';
        this.id = 'node_tibbit_26_start';
        this.linkedFeature = 'general';
        this.description = 'IR Processor Start Recording';

        this.inputs = [
            {
                name: 'Start Recording',
                portId: 'tbt26_start_recording',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit 26',
                settingType: SettingType.OPTION,
                refId: 'tibbit_26',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const TIBBIT = this.getSettingValue('TIBBIT');
        const tibbit = project.getFeature(TIBBIT);
        if (tibbit === undefined) {
            return blocks;
        }
        const tibbitName = tibbit.getSettingValue('NAME');
        const functionName = `${tibbitName}_data_available`;

        const links = project.getNodeLinks(this, 'tbt26_start_recording');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            if (project.runtime === 'tios') {
                blocks.push({
                    location: link.getSourceId(),
                    blockType: BlockType.CODE,
                    id: link.getID(),
                    template: `
    tbt26_start_recording(NO,YES,&h138, ${tibbitName}_CS, ${tibbitName}_channel)`,
                });
            }
        }

        return blocks;
    }
}
